<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }} <p style="color: #2AD3DA;">{{ data1['price'] }}</p></div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write" @mouseover="changeIndustrialFlag(97)"
               @click="toTwoPage('/hydrogen/twoPage/industry', '97')"
               :class="{'title-write-red' : industryFlag===97}">国内地区
          </div>
          <div class="title-write" @mouseover="changeIndustrialFlag(98)"
               @click="toTwoPage('/hydrogen/twoPage/industry', '98')"
               :class="{'title-write-red' : industryFlag===98}">国内外资讯
          </div>
          <div class="title-write" @mouseover="changeIndustrialFlag(111)"
               @click="toTwoPage('/hydrogen/twoPage/industry', '111')"
               :class="{'title-write-red' : industryFlag===111}">政策汇总
          </div>
          <span class="title-more fr" @click="toTwoPage('/hydrogen/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 97">
          <ul>
            <li v-for="(item, index) in industryListOne" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/industry', item.id, 97)">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 98">
          <ul>
            <li v-for="(item, index) in industryListTwo" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/industry', item.id, 98)">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 111">
          <ul>
            <li v-for="(item, index) in industryListThree" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/industry', item.id, 111)">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <ClassificationHeader :name="'价格'" :flag="false" :unit="false"
                                :params="{title:'价格',typeList:[ '氢气企业', '氢气地区', '重点氢气企业', '商品氢', '电堆']}"
                                :url="'/hydrogen/twoPage/price'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="priceFlag = 'issue_hydrogen_company_price'"
                style="width:74px;font-size: 12px"
                @click="toTwoPage('/hydrogen/twoPage/price', 'issue_hydrogen_company_price')"
                :class="{'stockFlag':priceFlag === 'issue_hydrogen_company_price'}">氢气企业</span>
          <span class="classification-tabs-three" @mouseover="priceFlag = 'issue_hydrogen_area_price'"
                style="width:74px;font-size: 12px"
                @click="toTwoPage('/hydrogen/twoPage/price', 'issue_hydrogen_area_price')"
                :class="{'stockFlag':priceFlag === 'issue_hydrogen_area_price'}">氢气地区</span>
          <span class="classification-tabs-three" @mouseover="priceFlag = 'manual_hydrogen_heavy_company_price'"
                style="width:74px;font-size: 12px"
                @click="toTwoPage('/hydrogen/twoPage/price', 'manual_hydrogen_heavy_company_price')"
                :class="{'stockFlag':priceFlag === 'manual_hydrogen_heavy_company_price'}">重点氢气企业</span>
          <span class="classification-tabs-three" @mouseover="priceFlag = '101'"
                style="width:74px;font-size: 12px"
                @click="toTwoPage('/hydrogen/twoPage/price', '101')"
                :class="{'stockFlag':priceFlag === '101'}">商品氢</span>
          <span class="classification-tabs-three" @mouseover="priceFlag = '102'"
                style="width:74px;font-size: 12px"
                @click="toTwoPage('/hydrogen/twoPage/price', '102')"
                :class="{'stockFlag':priceFlag === '102'}">电堆</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_hydrogen_company_price'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/hydrogen/price', item.completeOriginalDate, 'issue_hydrogen_company_price')">
              <i></i>
              <p>{{ item.date + '氢气企业价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_hydrogen_area_price'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/hydrogen/price', item.completeOriginalDate, 'issue_hydrogen_area_price')">
              <i></i>
              <p>{{ item.date + '氢气地区价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'manual_hydrogen_heavy_company_price'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceThreeList" :key="index"
                 @click="goDetail('/hydrogen/price', item.completeOriginalDate, 'manual_hydrogen_heavy_company_price')">
              <i></i>
              <p>{{ item.date + '重点氢气企业价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === '101'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceFourList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/priceXin', item.id, '101')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === '102'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceFiveList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/priceXin', item.id, '102')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <img style="margin-bottom: -6px;" src="../../assets/images/qingqi.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;height: 33px;font-size: 24px;font-weight: 500;color: #fff;line-height: 33px;">
            氢气市场点评</p>
          <span @click="toTwoPage('/hydrogen/twoPage/comment')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div"
                 v-for="(item, index) in commentList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/comment', item.id, '99')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/hydrogen/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/hydrogen/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/hydrogen/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/hydrogen/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'重点企业开工率'" :flag="false" :unit="false" :neibu="true"
                                :params="{title:'重点企业开工率'}"
                                :url="'/hydrogen/twoPage/rate'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div"
                 v-for="(item, index) in rateList" :key="index"
                 @click="goDetail('/hydrogen/rate', item.completeOriginalDate, 'manual_hydrogen_rate')">
              <i></i>
              <p>{{ item.date + '重点企业氢气开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'重点企业产量'" :flag="false" :unit="false" :neibu="true"
                                :params="{title:'重点企业产量',}"
                                :url="'/hydrogen/twoPage/yield'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div"
                 v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/hydrogen/yield', item.completeOriginalDate, 'manual_hydrogen_yield')">
              <i></i>
              <p>{{ item.date + '重点企业氢气产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>加氢站分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/hydrogen/map')" alt="">
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'氢能产业链'" :flag="false" :unit="false"
                                :params="{title:'氢能产业链',typeList:[ '制氢', '储运', '应用']}"
                                :url="'/hydrogen/twoPage/property'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="propertyFlag = '115'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/property', '115')"
                :class="{'stockFlag':propertyFlag === '115'}">制氢</span>
          <span class="classification-tabs-three" @mouseover="propertyFlag = '116'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/property', '116')"
                :class="{'stockFlag':propertyFlag === '116'}">储运</span>
          <span class="classification-tabs-three" @mouseover="propertyFlag = '114'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/property', '114')"
                :class="{'stockFlag':propertyFlag === '114'}">应用</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="propertyFlag === '115'">
            <div class="classification-content-div"
                 v-for="(item, index) in propertyOneList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/property', item.id, '115')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="propertyFlag === '116'">
            <div class="classification-content-div"
                 v-for="(item, index) in propertyTwoList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/property', item.id, '116')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="propertyFlag === '114'">
            <div class="classification-content-div"
                 v-for="(item, index) in propertyThreeList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/property', item.id, '114')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'加氢站'" :flag="false" :unit="false"
                                :params="{title:'加氢站',typeList:[ '项目动态', '零售价格', '运营', '项目一览表']}"
                                :url="'/hydrogen/twoPage/station'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="stationFlag = '105'"
                style="font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/station', '105')"
                :class="{'stockFlag':stationFlag === '105'}">项目动态</span>
          <span class="classification-tabs-three" @mouseover="stationFlag = '106'"
                style="font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/station', '106')"
                :class="{'stockFlag':stationFlag === '106'}">零售价格</span>
          <span class="classification-tabs-three" @mouseover="stationFlag = '107'"
                style="font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/station', '107')"
                :class="{'stockFlag':stationFlag === '107'}">运营</span>
          <span class="classification-tabs-three" @mouseover="stationFlag = '6'"
                style="font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/station', '6')"
                :class="{'stockFlag':stationFlag === '6'}">项目一览表</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stationFlag === '105'">
            <div class="classification-content-div"
                 v-for="(item, index) in stationOneList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/station', item.id, '105')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stationFlag === '106'">
            <div class="classification-content-div"
                 v-for="(item, index) in stationTwoList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/station', item.id, '106')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stationFlag === '107'">
            <div class="classification-content-div"
                 v-for="(item, index) in stationThreeList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/station', item.id, '107')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stationFlag === '6'">
            <div class="classification-content-div" v-for="(item, index) in stationFourList" :key="index">
              <i></i>
              <p style="width: 200px;" @click="downloadReportStation(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'燃料电池'" :flag="false" :unit="false"
                                :params="{title:'燃料电池',typeList:[ '公告车型数', '燃料电池汽车产销', '应用情况']}"
                                :url="'/hydrogen/twoPage/battery'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="batteryFlag = '108'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/battery', '108')"
                :class="{'stockFlag':batteryFlag === '108'}">公告车型数</span>
          <span class="classification-tabs-three" @mouseover="batteryFlag = '109'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/battery', '109')"
                :class="{'stockFlag':batteryFlag === '109'}">燃料电池汽车产销</span>
          <span class="classification-tabs-three" @mouseover="batteryFlag = '10'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/battery', '10')"
                :class="{'stockFlag':batteryFlag === '10'}">应用情况</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="batteryFlag === '108'">
            <div class="classification-content-div"
                 v-for="(item, index) in batteryOneList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/battery', item.id, '108')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="batteryFlag === '109'">
            <div class="classification-content-div"
                 v-for="(item, index) in batteryTwoList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/battery', item.id, '109')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="batteryFlag === '10'">
            <div class="classification-content-div"
                 v-for="(item, index) in batteryThreeList" :key="index">
              <i></i>
              <p style="width: 200px;" @click="downloadBattery(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'热点聚焦'" :flag="true" :unit="false"
                                :url="'/hydrogen/twoPage/project'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in projectList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/project', item.id, '103')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术突破'" :flag="true" :unit="false"
                                :url="'/hydrogen/twoPage/plan'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in planList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/plan', item.id, '104')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'相关报告'" :flag="true" :unit="false"
                                :url="'/hydrogen/twoPage/month'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in monthList" :key="index">
              <i></i>
              <p style="width: 200px;" @click="downloadMonth(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'项目数据库'" :flag="false" :unit="false"
                                :params="{title:'项目数据库',typeList:[ '气氢', '液氢', '绿氢']}"
                                :url="'/hydrogen/twoPage/database'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="databaseFlag = '117'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/database', '117')"
                :class="{'stockFlag':databaseFlag === '117'}">气氢</span>
          <span class="classification-tabs-three" @mouseover="databaseFlag = '7'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/database', '7')"
                :class="{'stockFlag':databaseFlag === '7'}">液氢</span>
          <span class="classification-tabs-three" @mouseover="databaseFlag = '8'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/hydrogen/twoPage/database', '8')"
                :class="{'stockFlag':databaseFlag === '8'}">绿氢</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="databaseFlag === '117'">
            <div class="classification-content-div"
                 v-for="(item, index) in databaseOneList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/hydrogen/database', item.id, '117')">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="databaseFlag === '7'">
            <div class="classification-content-div"
                 v-for="(item, index) in databaseTwoList" :key="index">
              <i></i>
              <p style="width: 200px;" @click="downloadDatabase(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="databaseFlag === '8'">
            <div class="classification-content-div"
                 v-for="(item, index) in databaseThreeList" :key="index">
              <i></i>
              <p v-if="item.fileType === '8'" style="width: 200px;" @click="downloadDatabase(item)">{{
                  item.fileTitle
                }}</p>
              <p v-if="item.fileType === '11'" style="width: 200px;"
                 @click="goDetail('/hydrogen/databaseWrite', item.id, '8')">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口'" :flag="false" :unit="false"
                                :params="{title:'进出口'}"
                                :url="'/hydrogen/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div"
                 v-for="(item, index) in exitList" :key="index"
                 @click="goDetail('/hydrogen/exit', item.completeOriginalDate, 'issue_hydrogen_exit')">
              <i></i>
              <p>{{ item.date + '氢气气体进出口统计' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="982px"
               :visible.sync="industrialFlag">
      <HydrogenIndustrial @closeIndustrialCh="closeIndustrial" v-if="industrialFlag" :data1="data1" :data2="data2"
                          :chainTitle="chainTitle"
                          :data3="data3"></HydrogenIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  batteryReDetail,
  databaseReDetail,
  industryDetail, monthDetail, projectStationDetail,
  reportDetail,
} from '@/api/hydrogen'
import {
  industryNoAuthList,
  priceNoAuthList,
  reportNoAuthList,
  exitNoAuthList,
  rateNoAuthList,
  yieldNoAuthList,
  chainList,
} from '@/api/petroleum'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import HydrogenIndustrial from '@/components/bigChart/hydrogenIndustrial'

export default {
  components: {
    ClassificationHeader,
    HydrogenIndustrial,
    Expect,
  },
  data() {
    return {
      industrialFlag: false,
      // 行业动态
      industryFlag: 97,
      industryListOne: [],
      industryListTwo: [],
      industryListThree: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 'issue_hydrogen_company_price',
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      priceFourList: [],
      priceFiveList: [],
      // 氢气市场点评
      commentList: [],
      // 开工率
      rateList: [],
      // 产量
      yieldList: [],
      // 氢能产业链
      propertyFlag: '115',
      propertyOneList: [],
      propertyTwoList: [],
      propertyThreeList: [],
      // 加氢站
      stationFlag: '105',
      stationOneList: [],
      stationTwoList: [],
      stationThreeList: [],
      stationFourList: [],
      // 燃料电池
      batteryFlag: '108',
      batteryOneList: [],
      batteryTwoList: [],
      batteryThreeList: [],
      // 热点聚焦
      projectList: [],
      // 技术突破
      planList: [],
      // 相关报告
      monthList: [],
      // 项目数据库
      databaseFlag: '117',
      databaseOneList: [],
      databaseTwoList: [],
      databaseThreeList: [],
      // 进出口
      exitList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_hydrogen_chain'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 97}).then(res => {
        this.industryListOne = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 98}).then(res => {
        this.industryListTwo = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 111}).then(res => {
        this.industryListThree = res.rows;
      })
      // 价格指数
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_hydrogen_company_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_hydrogen_area_price'}).then(res => {
        this.priceTwoList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'manual_hydrogen_heavy_company_price'}).then(res => {
        this.priceThreeList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '101'}).then(res => {
        this.priceFourList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '102'}).then(res => {
        this.priceFiveList = res.rows;
      })
      // 氢气市场点评
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '99'}).then(res => {
        this.commentList = res.rows;
      })
      // 氢气产量
      yieldNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'manual_hydrogen_yield'}).then(res => {
        this.yieldList = res.rows;
      })
      // 氢能产业链
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '115'}).then(res => {
        this.propertyOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '116'}).then(res => {
        this.propertyTwoList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '114'}).then(res => {
        this.propertyThreeList = res.rows;
      })
      // 加氢站
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '105'}).then(res => {
        this.stationOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '106'}).then(res => {
        this.stationTwoList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '107'}).then(res => {
        this.stationThreeList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 11, fileType: 6}).then(res => {
        this.stationFourList = res.rows;
      })
      // 燃料电池
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '108'}).then(res => {
        this.batteryOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '109'}).then(res => {
        this.batteryTwoList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 11, fileType: 10}).then(res => {
        this.batteryThreeList = res.rows;
      })
      // 热点聚焦
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: '103'}).then(res => {
        this.projectList = res.rows;
      })
      // 技术突破
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: '104'}).then(res => {
        this.planList = res.rows;
      })
      // 相关报告
      reportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 11, fileType: 9}).then(res => {
        this.monthList = res.rows;
      })
      // 项目数据库
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: '117'}).then(res => {
        this.databaseOneList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 11, fileType: 7}).then(res => {
        this.databaseTwoList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 11, fileType: '8,11'}).then(res => {
        this.databaseThreeList = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 11, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 11, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 11, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 开工率
      rateNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'manual_hydrogen_rate'}).then(res => {
        this.rateList = res.rows;
      })
      // 进出口
      exitNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_hydrogen_exit'}).then(res => {
        this.exitList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['氢能', '研究报告', '正文'], row['id']);
      })
    },
    downloadReportStation(row) {
      projectStationDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['氢能', '加氢站', '项目一览表'], row['id']);
      })
    },
    downloadDatabase(row) {
      databaseReDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['氢能', '项目数据库', '液氢'], row['id']);
      })
    },
    downloadBattery(row) {
      batteryReDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['氢能', '燃料电池', '应用情况'], row['id']);
      })
    },
    downloadMonth(row) {
      monthDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['氢能', '相关报告', '正文'], row['id']);
      })
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 切换tabs
     */
    changeIndustrialFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id, flag, other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/home/qingnengbanner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #0E743F;
      top: 21px;
      left: 231px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      text-align: center;
      top: 200px;
      line-height: 14px;
      left: 154px;
      width: 100px;
      height: 50px;
      color: #293E51;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor: pointer;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background: #fff;
        color: #D3131A;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background: #fff;
        color: #D3131A;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        font-size: 12px;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        border-top: 2px solid #D3131A;
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
